import styled from 'styled-components';
import React from 'react';
export const Code = styled.pre `
  background-color: black;
  color: #fff;
  padding: 1em;
  border-radius: 0.5em;
`;
export const Formatted = ({ obj }) => (React.createElement(Code, null, obj != null && JSON.stringify(obj, null, 2)));
//# sourceMappingURL=code.js.map